import React from 'react';
import { useCarousel } from './carousel';
import { cn } from '../../utils/cn';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

const _carouselContentVariants = cva(
    'rocco-carousel-content h-full overflow-hidden select-none',
    {
        variants: {
            variant: {
                default: '',
                fullPage: 'px-6 md:px-12',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    },
);

interface CarouselContentProps
    extends
        React.HTMLAttributes<HTMLDivElement>,
        VariantProps<typeof _carouselContentVariants> {
    /**
     * Classes for the overflow-hidden viewport div (the element embla
     * measures). Padding here keeps snap positions gutter-aligned while
     * overflow clips at the padding box — i.e. slides stay visible through
     * the gutter as they scroll (full-bleed carousels with inset snaps).
     */
    viewportClassName?: string;
}

export const CarouselContent = ({
    variant,
    className,
    viewportClassName,
    ...props
}: CarouselContentProps) => {
    const { carouselRef } = useCarousel();

    return (
        <div
            ref={carouselRef}
            className={cn(
                _carouselContentVariants({ variant }),
                'will-change-transform backface-hidden',
                viewportClassName,
            )}
        >
            <div className={cn('flex h-full', className)} {...props} />
        </div>
    );
};
